import { useAuthContext } from '@contexts/authContext'
import ModalContainer from '@elements/ModalContainer'
import AgeVerification from '@forms/AgeVerification'
import { useNavigate } from 'react-router-dom'

const ThirdPartyAgeVerificationModal = ({ isOpen }) => {
  const { registerThirdParty } = useAuthContext()
  const navigate = useNavigate()

  const handleConfirmation = () => {
    // Create Google User
    console.log('creating google user')
    registerThirdParty()
      .then(() => {
        console.log('User Created Successfully')
        // Redirect to home
        console.log('Redirecting to Home')
        navigate('/map')
      })
  }

  return (
    <ModalContainer open={isOpen}>
      <AgeVerification afterConfirmationCallback={handleConfirmation} />
    </ModalContainer>
  )
}

export default ThirdPartyAgeVerificationModal
